import React from 'react';

import style from './index.module.scss';

const NmcInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Обоснование НМЦ</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Мгновенно подобрать контракты для обоснования начальной максимальной цены
        </div>
        <div className={style.descriptionItem}>Прогнозировать цены на товары, работы или услуги</div>
      </div>
    </div>
  </>
);

export default NmcInfo;
